<template>
    <div class="detail-page">
        <van-nav-bar title="媒体详情" left-arrow @click-left="$router.back()" fixed placeholder />

        <div class="detail-container">
            <!-- 实景图 hero -->
            <div class="hero-image" v-if="imageUrl" @click="previewImage">
                <img :src="imageUrl" />
            </div>

            <!-- 基本信息 -->
            <div class="info-card overlap-card">
                <div class="card-head">
                    <van-icon name="orders-o" class="card-icon" />
                    <span class="card-title">基本信息</span>
                </div>
                <div class="card-body">
                    <div class="info-row">
                        <span class="ir-label">媒体名称</span>
                        <span class="ir-value">{{ screenName || '--' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="ir-label">分辨率</span>
                        <span class="ir-value">{{ resolution || '--' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="ir-label">开屏时长</span>
                        <span class="ir-value">{{ turnTime || '--' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="ir-label">所在区域</span>
                        <span class="ir-value">{{ regionText || '--' }}</span>
                    </div>
                    <div class="info-row" @click="viewMap">
                        <span class="ir-label">具体位置</span>
                        <span class="ir-value link">{{ address || '--' }}</span>
                        <van-icon name="location" class="map-icon" />
                    </div>
                    <div class="info-row">
                        <span class="ir-label">场景</span>
                        <span class="ir-value">{{ sceneText || '--' }}</span>
                    </div>
                </div>
            </div>

            <!-- 屏主信息 -->
            <div class="info-card">
                <div class="card-head">
                    <van-icon name="manager-o" class="card-icon" />
                    <span class="card-title">屏主信息</span>
                </div>
                <div class="card-body">
                    <div class="info-row">
                        <span class="ir-label">联系人</span>
                        <span class="ir-value">{{ userName || '--' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="ir-label">电话</span>
                        <span v-if="userPhone" class="ir-value link" @click="callPhone">{{ userPhone }}</span>
                        <span v-else class="ir-value">--</span>
                    </div>
                    <div class="info-row">
                        <span class="ir-label">单位</span>
                        <span class="ir-value">{{ userCompanyName || '--' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部操作栏 -->
        <div class="footer-bar">
            <van-button v-if="showScreenControl" plain hairline type="info" class="foot-btn-small" @click="switchPlate('ON')">开屏</van-button>
            <van-button v-if="showScreenControl" plain hairline type="danger" class="foot-btn-small" @click="switchPlate('OFF')">关屏</van-button>
            <van-button type="info" round class="foot-btn-main" @click="handleMonitorClick">监播</van-button>
        </div>

        <!-- 短信验证弹窗 -->
        <van-dialog
            v-model="smsDialogVisible"
            title="手机短信验证"
            show-cancel-button
            :before-close="handleSmsConfirm"
        >
            <div class="sms-dialog-body">
                <p v-if="switchValue === 'OFF'" class="sms-warning">本操作会导致户外大屏立即黑屏，请谨慎操作！</p>
                <p class="sms-tip">{{ smsCount > 0 ? `已向 ${phone} 发送验证码` : `向 ${phone} 发送验证码` }}</p>
                <div class="sms-input-row">
                    <van-field v-model="smsCode" type="digit" maxlength="6" placeholder="请输入验证码" />
                    <van-button
                        size="small"
                        type="info"
                        :disabled="smsCount > 0"
                        @click="sendSmsCode"
                    >{{ smsCount > 0 ? `${smsCount}秒后重获取` : '获取验证码' }}</van-button>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { resourceUrl } from '@/utils/base';
import { SCREEN_CONTROL_CODES } from '@/utils/permission';

export default {
    name: 'MediaDetailView',
    data() {
        return {
            screenId: '',
            screenName: '',
            coverThumbnailUrl: '',
            realPictureUrl: '',
            resolution: '',
            turnTime: '',
            province: '',
            city: '',
            district: '',
            address: '',
            sceneModelArea: '',
            userCompanyName: '',
            userName: '',
            userPhone: '',
            longitude: '',
            latitude: '',
            smsDialogVisible: false,
            smsCode: '',
            smsCount: 0,
            smsTimer: null,
            switchOffParams: null,
            switchValue: '',
            phone: '',
        };
    },
    computed: {
        showScreenControl() {
            const userCode = window.sessionStorage.getItem('userCode') || '';
            return SCREEN_CONTROL_CODES.includes(userCode);
        },
        imageUrl() {
            if (this.coverThumbnailUrl) return this.coverThumbnailUrl;
            if (this.realPictureUrl) {
                const first = this.realPictureUrl.split(',')[0];
                return first ? resourceUrl + first : '';
            }
            return '';
        },
        regionText() {
            return [this.province, this.city, this.district].filter(Boolean).join('');
        },
        fullAddress() {
            return (this.province || '') + (this.city || '') + (this.district || '') + (this.address || '');
        },
        sceneText() {
            if (!this.sceneModelArea) return '';
            return this.sceneModelArea.split('/')[0] || '';
        },
    },
    created() {
        const q = this.$route.query;
        this.screenId = q.screenId || '';
        this.screenName = q.screenName || '';
        this.coverThumbnailUrl = q.coverThumbnailUrl || '';
        this.realPictureUrl = q.realPictureUrl || '';
        this.resolution = q.resolution || '';
        this.turnTime = q.turnTime || '';
        this.province = q.province || '';
        this.city = q.city || '';
        this.district = q.district || '';
        this.address = q.address || '';
        this.sceneModelArea = q.sceneModelArea || '';
        this.userCompanyName = q.userCompanyName || '';
        this.userName = q.userName || '';
        this.userPhone = q.userPhone || '';
        this.longitude = q.longitude || '';
        this.latitude = q.latitude || '';

        const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo') || '{}');
        this.phone = userInfo.phone ? userInfo.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '';
    },
    beforeDestroy() {
        if (this.smsTimer) clearInterval(this.smsTimer);
    },
    methods: {
        previewImage() {
            if (this.imageUrl) {
                ImagePreview({
                    images: [this.imageUrl],
                    startPosition: 0,
                });
            }
        },
        viewMap() {
            this.$router.push({
                path: '/map',
                query: {
                    lng: this.longitude,
                    lat: this.latitude,
                    name: this.screenName || '媒体位置',
                    address: this.fullAddress,
                },
            });
        },
        callPhone() {
            if (this.userPhone) {
                window.location.href = 'tel://' + this.userPhone;
            }
        },
        handleMonitorClick() {
          this.$router.push({
            path: '/singleMonitor',
            query: { screenId: this.screenId },
          });
        },
        switchPlate(value) {
            this.switchValue = value;
            const params = {
                screenIdList: [this.screenId],
                value,
                operationType: [0],
            };
            this.$dialog.confirm({
                title: '注意',
                message: `确定${value === 'ON' ? '开屏' : '关屏'}吗？`,
            }).then(() => {
                if (value === 'ON') {
                    // 开屏：直接执行，不需要验证码
                    this.doSwitchPlate(params);
                } else {
                    // 关屏：需要短信验证码
                    this.switchOffParams = params;
                    this.smsCode = '';
                    this.smsDialogVisible = true;
                }
            }).catch(() => {});
        },
        async doSwitchPlate(params) {
            try {
                const res = await this.$post('/monitor/monitorscreen/controlOnOffScreen', params);
                if (res.rescode === 200) {
                    this.$toast.success('操作成功');
                    return true;
                } else {
                    this.$toast(res.msg || '操作失败');
                    return false;
                }
            } catch (error) {
                console.error(error);
                this.$toast('操作失败');
                return false;
            }
        },
        async sendSmsCode() {
            try {
                const res = await this.$get('/smsSendCode', { phone: '' });
                if (res.rescode === 200) {
                    this.$toast.success('验证码已发送');
                    this.smsCount = 59;
                    this.smsTimer = setInterval(() => {
                        this.smsCount -= 1;
                        if (this.smsCount <= 0) clearInterval(this.smsTimer);
                    }, 1000);
                } else {
                    this.$toast(res.msg || '发送失败');
                }
            } catch (error) {
                this.$toast('发送短信频繁，请稍后重试');
            }
        },
        handleSmsConfirm(action, done) {
            if (action === 'confirm') {
                const code = this.smsCode.trim();
                if (!code || code.length < 6) {
                    this.$toast('请输入6位验证码');
                    done(false);
                    return;
                }
                const params = { ...this.switchOffParams, code };
                this.doSwitchPlate(params).then(success => {
                    if (success) {
                        this.switchOffParams = null;
                        this.smsDialogVisible = false;
                        done();
                    } else {
                        done(false);
                    }
                });
            } else {
                this.switchOffParams = null;
                done();
            }
        },
    },
};
</script>

<style scoped>
.detail-page {
    min-height: 100vh;
    background: #f4f6f9;
    display: flex;
    flex-direction: column;
}

.detail-container {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 84px;
}

/* 实景图 hero */
.hero-image {
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;
    cursor: pointer;
}

.hero-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* 信息卡片 */
.info-card {
    background: #fff;
    border-radius: 12px;
    margin: 0 12px 10px;
    overflow: hidden;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}

/* 覆盖在实景图上的卡片 */
.overlap-card {
    margin-top: -24px;
    position: relative;
    z-index: 1;
}

.card-head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 11px 14px;
    border-bottom: 1px solid #f5f5f5;
}

.card-icon {
    color: #1989fa;
    font-size: 16px;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
}

.card-body {
    padding: 4px 14px 10px;
}

/* 信息行 */
.info-row {
    display: flex;
    align-items: flex-start;
    padding: 9px 0;
    font-size: 13.5px;
    border-bottom: 1px solid #f7f8fa;
}

.info-row:last-child {
    border-bottom: none;
}

.ir-label {
    color: #969799;
    flex-shrink: 0;
    min-width: 70px;
}

.ir-value {
    color: #333;
    text-align: right;
    flex: 1;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ir-value.link {
    color: #1989fa;
    cursor: pointer;
}

.map-icon {
    color: #1989fa;
    font-size: 18px;
    margin-left: 4px;
    flex-shrink: 0;
}

/* 底部操作栏 */
.footer-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 12px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 99;
}

.foot-btn-small {
   flex: 1;
}

.foot-btn-main {
    flex: 3;
}

/* 短信验证弹窗 */
.sms-dialog-body {
    padding: 16px;
}

.sms-warning {
    color: #f5222d;
    font-size: 14px;
    margin-bottom: 8px;
}

.sms-tip {
    font-size: 14px;
    color: #333;
    margin-bottom: 12px;
}

.sms-input-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.sms-input-row .van-field {
    flex: 1;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
}
</style>
